import { render, staticRenderFns } from "./contract-attorney-agent.component.vue?vue&type=template&id=7508b70e"
import script from "./contract-attorney-agent.component.vue?vue&type=script&lang=ts"
export * from "./contract-attorney-agent.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports